import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground",
        constructive:
          "border-transparent bg-emerald-100 text-emerald-700",
        "severity-high":
          "border-transparent bg-red-500 text-white",
        "severity-medium":
          "border-transparent bg-orange-500 text-white",
        "severity-low":
          "border-transparent bg-yellow-500 text-white",
        "impact-high":
          "border-transparent bg-emerald-500 text-white",
        "impact-medium":
          "border-transparent bg-teal-500 text-white",
        "impact-low":
          "border-transparent bg-cyan-500 text-white",
        "category-formal":
          "border-transparent bg-blue-500 text-white",
        "category-informal":
          "border-transparent bg-green-500 text-white",
        "category-appeal":
          "border-transparent bg-purple-500 text-white",
        "category-causation":
          "border-transparent bg-orange-500 text-white",
        "category-ambiguity":
          "border-transparent bg-indigo-500 text-white",
        "category-constructive":
          "border-transparent bg-emerald-500 text-white",
        info:
          "border-transparent bg-indigo-100 text-indigo-700",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
